import IOverlay from './IOverlay'
import Axios from 'axios'
import { isString, isArray } from 'util'

/**
 * 叠置分析
 * 后台分析模式
 */
export default class IServerOperation extends IOverlay {
    /**
     * 构造函数
     * @param {String} operation 必须 类型，用来确定服务类型
     * @param {String} serviceUrl 必须 服务地址
     * @param {String} proxyUrl 非必须
     */
    constructor(operation, serviceUrl, proxyUrl = '') {
        super()

        this.operation = operation
        // url 参数
        this.serviceUrl = serviceUrl
        this.proxyUrl = proxyUrl

        // 服务类型
        this._type = !serviceUrl.endsWith('/overlapservice') ? 'WPS' : 'SAS'
    }

    /**
     * 发送请求
     * @param {String} execute
     * @override
     */
    async _process(fc1, fc2, tolerance) {
        return IServerOperation.PROCESSES[this._type].call(
            this,
            fc1,
            fc2,
            tolerance
        )
    }

    /**
     * 构建请求体
     * @abstract
     * @param {*} fc1
     * @param {*} fc2
     * @param {*} tolerance
     */
    absBuildExecute(fc1, fc2, tolerance) {
        return IServerOperation.EXCUTES[this._type].call(
            this,
            fc1,
            fc2,
            tolerance
        )
    }

    // 请求方法体（wps和sas）
    static PROCESSES = {
        async SAS(fc1, fc2, tolerance) {
            const execute = this.absBuildExecute(fc1, fc2, tolerance)
            return Axios.post(
                this.proxyUrl + this.serviceUrl + '?1=1',
                execute,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    params: {
                        VERSION: '1.0.0',
                        SERVICE: 'OverlapService',
                        REQUEST: 'SpatialAnalysis'
                    }
                }
            ).then(({ data }) => {
                try {
                    return data.results[0].features.map(f => {
                        return {
                            type: 'Feature',
                            properties: f.attributes,
                            geometry: f.geometry
                        }
                    })
                } catch (error) {
                    throw '叠置分析失败！'
                }
            })
        },
        async WPS(fc1, fc2, opt_options) {
            const execute = this.absBuildExecute(fc1, fc2, opt_options)

            const url =
                this.proxyUrl +
                this.serviceUrl +
                (this.serviceUrl.endsWith('/Execute') ? '' : '/Execute')

            return Axios.post(url, execute, {
                headers: { 'Content-Type': 'text/xml' }
            }).then(({ data }) => {
                if (!data || data === '' || data.includes('ServiceException')) {
                    throw '叠加分析失败！'
                }
                try {
                    return IServerOperation.GML2GeoJson(data)
                } catch (error) {
                    console.error('wps error:', error)
                    throw '叠加分析失败！'
                }
            })
        }
    }

    // 请求体构建方法（wps和sas）
    static EXCUTES = {
        SAS(fc1, fc2, tolerance) {
            const requestBody = {
                SpatialAnalysis: {
                    service: 'OverlapService',
                    version: '1.0.0',
                    origionLayer: {
                        type: 'FeatureCollection',
                        features: fc1.map(f => {
                            f["attributes"] = f.properties
                            delete f.properties
                            return f
                        })
                    },
                    targetLayer: {
                        type: 'FeatureCollection',
                        features: fc2.map(f => {
                            f["attributes"] = f.properties
                            delete f.properties
                            return f
                        })
                    },
                    outPutFormat: 'geojson',
                    operator: this.operation,
                    isSynchronization: 'true',
                    tolerance: `${tolerance || '0.0000001'}`
                }
            }
            return requestBody
        },
        WPS(fc1, fc2, opt_options) {
            const executeTmpl = require(`../tmpls/${this.operation}.js`).default
            const _fc1 = IServerOperation.GeoJson2GML(fc1)
            const _fc2 = IServerOperation.GeoJson2GML(fc2)

            const execute = executeTmpl
                .replace('{INPUT1}', _fc1)
                .replace('{INPUT2}', _fc2)
            return execute
        }
    }

    /**
     * 数据转换
     * @param {*} geojson
     */
    static GeoJson2GML(geojson) {
        if (isArray(geojson)) {
            geojson = {
                type: 'FeatureCollection',
                features: geojson
            }
        }
        return new GeoGlobe.Format.GML().write(
            new GeoGlobe.Format.GeoJSON().read(geojson)
        )
    }

    /**
     * 数据转换
     * @param {*} gmlStr
     */
    static GML2GeoJson(gmlStr) {
        let geojson = new GeoGlobe.Format.GeoJSON().write(
            new GeoGlobe.Format.GML().read(gmlStr)
        )
        if (isString(geojson)) {
            geojson = JSON.parse(geojson)
        }
        return geojson
    }
}
